import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ListAlumni from "./List";
import { ALUMNI } from "utils/constants";

import permissions from "app/permissions";
import ShowAlumni from "./Show";

//permissions
export const resources = {
  isMenu: true,
  icon: <ManageAccountsIcon />,
  name: ALUMNI,
  title: "Алумни профили",
  list: <ListAlumni />,
  show: <ShowAlumni />,
  permission: permissions.canPreviewAlumni,
  showPermission: permissions.canPreviewAlumni,
};
